/* Day별 색상 — 일정표에서 날짜를 구분하는 정성적(qualitative) 팔레트.
   8개 색이 서로 확실히 구분되면서도 채도·명도가 비슷해 한 세트로 읽힌다.
   인디고에서 시작해 브랜드 색과 이어지고, 이후 색상환을 고르게 돈다. */

// 기준 색상 (아바타·구분선 등에 그대로 사용)
export const DAY_COLORS = [
  "#6366F1", // 1 인디고
  "#14B8A6", // 2 틸
  "#8B5CF6", // 3 바이올렛
  "#0EA5E9", // 4 스카이
  "#EC4899", // 5 핑크
  "#F59E0B", // 6 앰버
  "#10B981", // 7 에메랄드
  "#A855F7", // 8 퍼플
  "#3B82F6", // 9 블루
  "#F43F5E", // 10 로즈
  "#06B6D4", // 11 시안
  "#7C3AED", // 12 딥 바이올렛
  "#22C55E", // 13 그린
  "#4F46E5", // 14 딥 인디고
];

// 카드 텍스트·배지 강조색 — 라이트 배경에서 읽히도록 한 단계 진하게
export const DAY_ACCENT = [
  "#4F46E5", "#0D9488", "#7C3AED", "#0284C7",
  "#DB2777", "#D97706", "#059669", "#9333EA",
];

// Day별 카드 배경 — 라이트 모드
export const DAY_BG_LIGHT = [
  "linear-gradient(135deg, rgba(99,102,241,0.13), rgba(99,102,241,0.05))",   // 1 인디고
  "linear-gradient(135deg, rgba(20,184,166,0.13), rgba(20,184,166,0.05))",   // 2 틸
  "linear-gradient(135deg, rgba(139,92,246,0.13), rgba(139,92,246,0.05))",   // 3 바이올렛
  "linear-gradient(135deg, rgba(14,165,233,0.13), rgba(14,165,233,0.05))",   // 4 스카이
  "linear-gradient(135deg, rgba(236,72,153,0.12), rgba(236,72,153,0.05))",   // 5 핑크
  "linear-gradient(135deg, rgba(245,158,11,0.14), rgba(245,158,11,0.05))",   // 6 앰버
  "linear-gradient(135deg, rgba(16,185,129,0.13), rgba(16,185,129,0.05))",   // 7 에메랄드
  "linear-gradient(135deg, rgba(168,85,247,0.13), rgba(168,85,247,0.05))",   // 8 퍼플
];

// Day별 카드 배경 — 다크 모드
export const DAY_BG_DARK = [
  "linear-gradient(135deg, rgba(99,102,241,0.26), rgba(99,102,241,0.10))",
  "linear-gradient(135deg, rgba(20,184,166,0.26), rgba(20,184,166,0.10))",
  "linear-gradient(135deg, rgba(139,92,246,0.26), rgba(139,92,246,0.10))",
  "linear-gradient(135deg, rgba(14,165,233,0.26), rgba(14,165,233,0.10))",
  "linear-gradient(135deg, rgba(236,72,153,0.24), rgba(236,72,153,0.10))",
  "linear-gradient(135deg, rgba(245,158,11,0.24), rgba(245,158,11,0.10))",
  "linear-gradient(135deg, rgba(16,185,129,0.26), rgba(16,185,129,0.10))",
  "linear-gradient(135deg, rgba(168,85,247,0.26), rgba(168,85,247,0.10))",
];

// Day별 카드 테두리
export const DAY_BORDER_LIGHT = [
  "rgba(99,102,241,0.38)",
  "rgba(20,184,166,0.38)",
  "rgba(139,92,246,0.38)",
  "rgba(14,165,233,0.38)",
  "rgba(236,72,153,0.36)",
  "rgba(245,158,11,0.40)",
  "rgba(16,185,129,0.38)",
  "rgba(168,85,247,0.38)",
];

export const DAY_BORDER_DARK = [
  "rgba(129,140,248,0.50)",
  "rgba(45,212,191,0.50)",
  "rgba(167,139,250,0.50)",
  "rgba(56,189,248,0.50)",
  "rgba(244,114,182,0.48)",
  "rgba(251,191,36,0.50)",
  "rgba(52,211,153,0.50)",
  "rgba(192,132,252,0.50)",
];
